<template>
  <b-modal
    id="modal-update-result"
    :modal-class="{
      cancel: data.result == 0,
      rain: data.result == 1,
      'no-rain': data.result == 2,
    }"
    cancel-variant="outline-secondary"
    :ok-title="$t('field.defineResult')"
    :cancel-title="$t('button.close')"
    centered
    :title="title"
    @ok="handleOk"
    size="md"
  >
    <validation-observer ref="updateResultForm" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="updateResultForm"
        :form="$refs.updateResultForm"
        :disabled="invalid"
        @submit="submit"
        class="define-result-form"
      >
        <b-form-radio-group
          class="button-checkbox"
          v-model="data.result"
          name="result"
          buttons
          button-variant="outline-secondary"
        >
          <b-form-radio
            :value="result.id"
            v-for="result in results"
            :key="`result-${result.id}`"
            buttons
            :class="result.class"
          >
            <span>
              {{ $t(result.label) }}
            </span>
          </b-form-radio>
        </b-form-radio-group>
      </n-form-confirmation>
    </validation-observer>

    <template #modal-ok>
      <b-spinner small label="Spinning" v-if="loading"></b-spinner>
      <span v-else>{{ $t("field.defineResult") }}</span>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormRadio,
  BRow,
  BCol,
  BSpinner,
} from "bootstrap-vue";
import NFormConfirmation from "@/components/NFormConfirmation";
import Repository from "@/repositories/RepositoryFactory";
import moment from "moment";

const MatchRepository = Repository.get("match");

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BSpinner,
    NFormConfirmation,
  },
  data() {
    return {
      title: "",
      loading: false,
      key: 1,
      data: {
        id: null,
        result: null,
      },
      results: [
        {
          id: 0,
          label: "field.cancel",
          class: "cancel",
        },
        {
          id: 1,
          label: "field.rain",
          class: "rain",
        },
        {
          id: 2,
          label: "field.noRain",
          class: "no-rain",
        },
      ],
    };
  },
  methods: {
    show(item) {
      const date = moment(item.betDate).format("DD-MM-YYYY");
      const startTime = moment(item.startTime, "HH:mm")
        .locale(this.$i18n.locale)
        .format("hh:mm a");
      const endTime = moment(item.endTime, "HH:mm")
        .locale(this.$i18n.locale)
        .format("hh:mm a");
      this.title = `${date} (${startTime} - ${endTime})`;

      this.data = {
        id: item.id,
        result: item.result,
      };
      this.key++;
      this.$bvModal.show("modal-update-result");
    },
    hide() {
      this.$bvModal.hide("modal-update-result");
    },
    handleOk(bvModal) {
      bvModal.preventDefault();
      if (this.loading) {
        return;
      }

      this.$refs.updateResultForm.validate().then((success) => {
        if (success) {
          this.$refs.formConfirmation.confirm();
        }
      });
    },
    submit() {
      this.loading = true;
      MatchRepository.updateResult(this.data.id, { result: this.data.result })
        .then((response) => {
          this.hide();
          this.$emit("success");
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.updateResultForm.setErrors(error.response?.data?.errors);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>